import { render } from "./theHeader.vue?vue&type=template&id=8d5fc06e&lang=pug&bindings={\"show\":\"data\",\"links\":\"data\"}"
import script from "./theHeader.vue?vue&type=script&lang=js"
export * from "./theHeader.vue?vue&type=script&lang=js"

import "./theHeader.vue?vue&type=style&index=0&lang=sass"
script.render = render

export default script